module.exports = __webpack_public_path__ + "img/Viaje.93709d0d.webp";